/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShadowSubsystemAction } from './ShadowSubsystemAction';
import {
    ShadowSubsystemActionFromJSON,
    ShadowSubsystemActionFromJSONTyped,
    ShadowSubsystemActionToJSON,
} from './ShadowSubsystemAction';
import type { ShadowSubsystemAuditStep } from './ShadowSubsystemAuditStep';
import {
    ShadowSubsystemAuditStepFromJSON,
    ShadowSubsystemAuditStepFromJSONTyped,
    ShadowSubsystemAuditStepToJSON,
} from './ShadowSubsystemAuditStep';
import type { ShadowSubsystemOutcome } from './ShadowSubsystemOutcome';
import {
    ShadowSubsystemOutcomeFromJSON,
    ShadowSubsystemOutcomeFromJSONTyped,
    ShadowSubsystemOutcomeToJSON,
} from './ShadowSubsystemOutcome';
import type { ShadowSubsystemScoring } from './ShadowSubsystemScoring';
import {
    ShadowSubsystemScoringFromJSON,
    ShadowSubsystemScoringFromJSONTyped,
    ShadowSubsystemScoringToJSON,
} from './ShadowSubsystemScoring';

/**
 * 
 * @export
 * @interface ShadowSubsystemResult
 */
export interface ShadowSubsystemResult {
    /**
     * 
     * @type {ShadowSubsystemOutcome}
     * @memberof ShadowSubsystemResult
     */
    outcome: ShadowSubsystemOutcome;
    /**
     * 
     * @type {string}
     * @memberof ShadowSubsystemResult
     */
    reason: string;
    /**
     * 
     * @type {ShadowSubsystemAction}
     * @memberof ShadowSubsystemResult
     */
    next_step?: ShadowSubsystemAction | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowSubsystemResult
     */
    missing_information?: Array<string>;
    /**
     * 
     * @type {ShadowSubsystemScoring}
     * @memberof ShadowSubsystemResult
     */
    scoring?: ShadowSubsystemScoring;
    /**
     * 
     * @type {Array<ShadowSubsystemAuditStep>}
     * @memberof ShadowSubsystemResult
     */
    audit_steps?: Array<ShadowSubsystemAuditStep>;
}

/**
 * Check if a given object implements the ShadowSubsystemResult interface.
 */
export function instanceOfShadowSubsystemResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "outcome" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function ShadowSubsystemResultFromJSON(json: any): ShadowSubsystemResult {
    return ShadowSubsystemResultFromJSONTyped(json, false);
}

export function ShadowSubsystemResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'outcome': ShadowSubsystemOutcomeFromJSON(json['outcome']),
        'reason': json['reason'],
        'next_step': !exists(json, 'next_step') ? undefined : ShadowSubsystemActionFromJSON(json['next_step']),
        'missing_information': !exists(json, 'missing_information') ? undefined : json['missing_information'],
        'scoring': !exists(json, 'scoring') ? undefined : ShadowSubsystemScoringFromJSON(json['scoring']),
        'audit_steps': !exists(json, 'audit_steps') ? undefined : ((json['audit_steps'] as Array<any>).map(ShadowSubsystemAuditStepFromJSON)),
    };
}

export function ShadowSubsystemResultToJSON(value?: ShadowSubsystemResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'outcome': ShadowSubsystemOutcomeToJSON(value.outcome),
        'reason': value.reason,
        'next_step': ShadowSubsystemActionToJSON(value.next_step),
        'missing_information': value.missing_information,
        'scoring': ShadowSubsystemScoringToJSON(value.scoring),
        'audit_steps': value.audit_steps === undefined ? undefined : ((value.audit_steps as Array<any>).map(ShadowSubsystemAuditStepToJSON)),
    };
}

